import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ReleaseNumberState } from "@tSchaedlerYesco/Store/Data/PlaceOrder/ReleaseNumberState";
import { ReleaseNumber } from "@tSchaedlerYesco/Types/CustomAPIModels";
import { Draft } from "immer";

const initialReleaseNumberState: ReleaseNumberState = {
    isLoading: false,
    value: undefined,
    releaseNumber: "",
};

const reducer = {
    "Data/PlaceOrder/BeginAddingReleaseNumber": (draft: Draft<ReleaseNumberState>) => {
        draft.isLoading = true;
    },

    "Data/PlaceOrder/AddReleaseNumber": (draft: Draft<ReleaseNumberState>, action: { result: ReleaseNumber }) => {
        draft.isLoading = false;
        draft.value = action.result;
        draft.releaseNumber = action.result.releaseNumber;
    },
};

export default createTypedReducerWithImmer(initialReleaseNumberState, reducer);
